import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card, CardBody, CardTitle, CardText,
  Container, Row, Col,
} from "reactstrap";
import { favoritesRepo } from "data/repositories/favoritesRepo";
import { provincesRepo } from "data/repositories/provincesRepo";
import { dealsRepo } from "data/repositories/dealsRepo";
import ThemeBadge from "components/ThemeBadge";
import EmptyState from "components/EmptyState";

export default function SavedPage() {
  const [provinces, setProvinces] = useState([]);
  const [deals, setDeals] = useState([]);

  useEffect(() => {
    const fav = favoritesRepo.get();
    const allProv = provincesRepo.list();
    const allDeals = dealsRepo.list();
    setProvinces(allProv.filter((p) => fav.provinceIds.includes(p.id)));
    setDeals(allDeals.filter((d) => fav.dealIds.includes(d.id)));
  }, []);

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h2 className="text-white mb-0">Kaydedilenler</h2>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        {/* Saved provinces */}
        <h4 className="mb-3">Kayıtlı İller</h4>
        {provinces.length === 0 ? (
          <EmptyState title="Kayıtlı il yok" description="Beğendiğiniz illeri favorilere ekleyin." />
        ) : (
          <Row className="mb-4">
            {provinces.map((p) => (
              <Col key={p.id} lg={4} md={6} xs={12} className="mb-3">
                <Card className="shadow h-100" tag={Link} to={`/admin/provinces/${p.id}`} style={{ textDecoration: "none" }}>
                  <CardBody>
                    <CardTitle tag="h5">{p.name}</CardTitle>
                    <CardText className="text-muted small">{p.slogan}</CardText>
                    <div>
                      {(p.themes || []).slice(0, 3).map((t) => (
                        <ThemeBadge key={t} theme={t} />
                      ))}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        )}

        {/* Saved deals */}
        <h4 className="mb-3">Kayıtlı Fırsatlar</h4>
        {deals.length === 0 ? (
          <EmptyState title="Kayıtlı fırsat yok" description="Beğendiğiniz fırsatları favorilere ekleyin." />
        ) : (
          <Row>
            {deals.map((d) => (
              <Col key={d.id} lg={4} md={6} xs={12} className="mb-3">
                <Card className="shadow h-100" tag={Link} to={`/admin/deals/${d.id}`} style={{ textDecoration: "none" }}>
                  <CardBody>
                    <CardTitle tag="h5">{d.title}</CardTitle>
                    <CardText className="text-muted small">{d.description}</CardText>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </>
  );
}
